import { render, staticRenderFns } from "./home.vue?vue&type=template&id=05a9132e"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=05a9132e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports